import $ from 'jquery'
import Isotope from 'isotope-layout'
import { debounce, getTextNodesIn } from '../functions'


var faqIsoElement = document.querySelector('.js-faqs');

if (faqIsoElement) {
    var faqIso = new Isotope(faqIsoElement, {
        itemSelector: '.js-iso-item',
        transitionDuration: 0,
    });
}

var currentSearch = ''
var currentCat = ''

const search = $('.js-faq-search').keyup(
    debounce(function () {
        const qsRegex = new RegExp(search.val(), 'gi')
        currentSearch = qsRegex

        faqSearch()
    }, 200)
)

search.on('blur', function () {
    const qsRegex = new RegExp(search.val(), 'gi')
    currentSearch = qsRegex

    faqSearch()
})

const input = $('.js-cat')

input.on('click', function () {
    $('.cat-selected').removeClass('cat-selected')
    $(this).addClass('cat-selected')

    const catId = $(this).data('id')
    currentCat = catId

    faqSearch()
})

function faqSearch() {
    faqIso.arrange({
        filter: function () {
            const post = $(this)
            const text = getTextNodesIn(post[0])

            let hasText = currentSearch ? text.match(currentSearch) : true

            let catMatched = true
            let cats = post.attr('data-categories').split(',')

            if (currentCat != '' && cats) {
                if (cats.indexOf(currentCat.toString()) == -1) {
                    catMatched = false
                }
            }

            return hasText && catMatched
        },
    })
}